import { createFileRoute, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductsInvoicingPage } from "src/pages/CoachProductsInvoicingPage";
import { invoicingIntegrationQueryOptions } from "src/queries/invoicingIntegration";

export const Route = createFileRoute("/_auth/_coach/products/_tabs/invoicing")({
  component: CoachProductsInvoicingPage,
  ssr: true,
  async loader({ context }) {
    return loaderHandler(async () => {
      const invoicing = await context.queryClient.query({
        ...invoicingIntegrationQueryOptions(),
        staleTime: "static",
      });

      if (invoicing.providers.length === 0) {
        throw redirect({ to: "/products" });
      }

      return { data: null };
    });
  },
});
